import { render, staticRenderFns } from "./EventSelector.vue?vue&type=template&id=5f708674&scoped=true"
import script from "./EventSelector.vue?vue&type=script&lang=js"
export * from "./EventSelector.vue?vue&type=script&lang=js"
import style0 from "./EventSelector.vue?vue&type=style&index=0&id=5f708674&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f708674",
  null
  
)

export default component.exports